import React, { useState } from "react";
import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import Button from "../Button/Button";
import { useGetUpdateGroupingItem } from "../../hooks/useCrm";
import { SimpleSelect1 } from "../SimpleSelect/SimpleSelect1";
import { InputField1 } from "../InputField1/InputField1";
import { useEffect } from "react";
const initvalue = {
  IdGropingNewUserCrm: null,
  TitleGroping: null,
  ContentGroping: null,
  LanguageGroping: null,
};
export const UpdateGroupingItemModal = ({
  show,
  handleClose,
  item,
  GroupingOption,
}) => {
  const [button] = useState(false);
  const [form, setForm] = useState(initvalue);
  const { mutateAsync: update } = useGetUpdateGroupingItem();
  useEffect(() => {
    if (item !== null) {
      setForm({
        ...form,
        IdGropingNewUserCrm: item?.IdGropingNewUserCrm,
        ContentGroping: item?.ContentGroping,
        LanguageGroping: item?.LanguageGroping,
        TitleGroping: item?.TitleGroping,
      });
    }
  }, [item]);
  const handleUpdate = async (data) => {
    await update(data);
  };
  return (
    <BootstrapModal
      modaltitle="ویرایش دسته بندی"
      handleClose={handleClose}
      show={show}
      moreButton={button}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <div className="bg-white row p-1 pb-3 rounded-b-lg">
        <div className="col-12">
          <SimpleSelect1
            res={GroupingOption}
            label="موضوع"
            onChange={(e) => setForm({ ...form, TitleGroping: e.value })}
            // value={{
            //   value: form.TitleGroping ? form.TitleGroping : "انتخاب کنید...",
            //   label: form.TitleGroping ? form.TitleGroping : "انتخاب کنید...",
            // }}
            defaultValue={{
              value: form?.TitleGroping,
              label: form?.TitleGroping,
            }}
          />
        </div>
        <div className="col-12">
          <InputField1
            placeholder="محتوا"
            label="محتوا"
            onChange={(e) =>
              setForm({ ...form, ContentGroping: e.target.value })
            }
            value={form?.ContentGroping ? form?.ContentGroping : ""}
          />
        </div>
        <div className="col-12">
          <SimpleSelect1
            res={[
              { value: "fa", label: "فارسی" },
              { value: "en", label: "انگلیسی" },
            ]}
            label="زبان"
            onChange={(e) => setForm({ ...form, LanguageGroping: e.value })}
            defaultValue={{
              value: form?.LanguageGroping,
              label:
                form?.LanguageGroping === "fa"
                  ? "فارسی"
                  : form.LanguageGroping === "en"
                  ? "انگلیسی"
                  : "",
            }}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12"></div>
        <div className="col-6 mt-2">
          <Button
            bgColor="#009ef7"
            color="#fff"
            onclick={() => {
              handleUpdate(form);
              handleClose();
            }}
          >
            ثبت
          </Button>
        </div>
        <div className="col-6 mt-2">
          <Button bgColor="#f1416c" color="#fff" onclick={handleClose}>
            انصراف
          </Button>
        </div>
      </div>
    </BootstrapModal>
  );
};
